/*
 * Copyright (c) 2022. Nedaware SL
 */

import {Caster} from "./caster";

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

/**
 * The number caster simply ensures that the value sent is a number and not a string
 */
export class NumberCaster implements Caster<any, number> {
    fromModel(modelValue: any | null): number | null {
        if (modelValue == null) {
            return modelValue;
        }

        if (typeof modelValue !== "number") {
            const number = Number(modelValue);
            if (isNaN(number)) {
                throw new Error(`Error casting ${modelValue}, it seems that the value is not a number.`);
            }
            return number;
        }
        return modelValue;
    }

    toModel(apiValue: number | null): any | null {
        return apiValue;
    }
}
